/**
 * @file object-form.ts
 * @description API сервис для работы с формами объектов в Task Manager приложении, который обеспечивает полный CRUD интерфейс для управления объектами различных типов через REST API. Предоставляет методы для получения, создания, обновления и удаления объектов с поддержкой табовых форм, идентификаторов объектов и передачи данных в различных форматах для универсального управления сущностями системы.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js', 'axios']
 * @related-files ['src/features/object-form/object-form.component.tsx', 'src/api/actions.ts']
 */

import { TApiData } from '@src/types';
import { getRequest, postRequest, putRequest, deleteRequest } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const ObjectFormService = {
    /**
     * Получает данные объекта по имени и идентификатору
     * @param {string} name - Имя типа объекта для получения
     * @param {string} [id] - Идентификатор конкретного объекта
     * @param {string} [tab] - Имя вкладки для табовых форм
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с данными объекта или ошибкой
     */
    get: async (
        name: string,
        id?: string | undefined,
        tab?: string | undefined
    ): Promise<AxiosResponse | AxiosError> => {
        const params: TApiData = {
            ...(id ? { id } : {}),
            ...(tab ? { tab } : {})
        };

        return await getRequest(`object/${name}`, params);
    },
    /**
     * Создает новый объект указанного типа
     * @param {string} name - Имя типа объекта для создания
     * @param {TApiData} data - Данные нового объекта
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с результатом создания или ошибкой
     */
    create: async (name: string, data: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postRequest(`object/${name}`, data, undefined);
    },
    /**
     * Сохраняет изменения существующего объекта
     * @param {string} name - Имя типа объекта для обновления
     * @param {TApiData} data - Обновленные данные объекта
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с результатом сохранения или ошибкой
     */
    save: async (name: string, data: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await putRequest(`object/${name}`, data, undefined);
    },
    /**
     * Удаляет объект указанного типа
     * @param {string} name - Имя типа объекта для удаления
     * @param {TApiData} data - Данные объекта с идентификатором для удаления
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с результатом удаления или ошибкой
     */
    delete: async (name: string, data: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await deleteRequest(`object/${name}`, data);
    }
};
